import {
  withCompPreviewInfo,
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import { CompInfoDependency } from '@wix/editor-elements-types';
import {
  FacebookShareDefinition,
  FacebookSharePlatformProps,
} from '../FacebookShare.types';
import { props as viewerPropsMapper } from './FacebookShare.mapper';

const viewerDeps = Object.keys(viewerPropsMapper.deps) as Array<
  CompInfoDependency
>;

const props = withCompPreviewProps<
  FacebookSharePlatformProps,
  FacebookShareDefinition
>()(['isSocialInteractionAllowed', ...viewerDeps], (deps, carmiData) => {
  const viewerProps = viewerPropsMapper.resolver(deps, carmiData);

  return {
    ...viewerProps,
    previewWrapperProps: {
      blockingLayer: !deps.isSocialInteractionAllowed
        ? { enabled: true, tooltipText: 'PREVIEW_TOOLTIP_GOTO_LIVE_SITE' }
        : undefined,
    },
  };
});

const css = withCompPreviewInfo<{ width?: string }, FacebookShareDefinition>()(
  ['isSocialInteractionAllowed'],
  ({ isSocialInteractionAllowed }) =>
    isSocialInteractionAllowed ? {} : { width: 'auto' },
);

export default createComponentPreviewMapperModel({
  props: props as any,
  css,
});
